import { extendTheme } from '@mui/joy/styles';

const fontFamilyPrimary = "Poppins, sans-serif";

export const theme = extendTheme({
  fontFamily: {
    body: fontFamilyPrimary,
    display: fontFamilyPrimary,
  },
  colorSchemes: {
    light: {
      palette: {
        primary: {
          50: '#E3F2FD',
          100: '#BBDEFB',
          200: '#90CAF9',
          300: '#64B5F6',
          400: '#42A5F5',
          500: '#1976D2',
          600: '#1565C0',
          700: '#0D47A1',
          800: '#0A3880',
          900: '#072A60',
        },

        background: {
          body: '#ffffff',
          surface: '#ffffff',
          level1: '#ffffff',
          level2: '#ffffff',
          popup: '#ffffff',
        },
      },
    },
    dark: {
      palette: {
        primary: {
          50: '#E3F2FD',
          100: '#BBDEFB',
          200: '#90CAF9',
          300: '#64B5F6',
          400: '#42A5F5',
          500: '#1976D2',
          600: '#1565C0',
          700: '#0D47A1',
          800: '#0A3880',
          900: '#072A60',
        },
        background: {
          body: '#000000',
          surface: '#000000',
          level1: '#000000',
          level2: '#000000',
          popup: '#000000',
        },
      },
    },
  },
  // components: {
  //   JoyChip: {
  //     defaultProps: {
  //       variant: 'outlined',
  //       color: 'neutral',
  //     },
  //     styleOverrides: {
  //       // `ownerState` contains the component props and internal state
  //       root: ({ ownerState, theme }) => {
          
  //         return {
  //           ...(ownerState.color === 'warning' && {
  //                 backgroundColor: 'yellow',
  //           }),
  //         }
  //       },
  //     },
  //   },
  // },
  
});

const lightTheme = {
  primary: 'rgba(215,113,88,1)',
  text: 'rgba(58,52,51,1)',
  textSecondary: 'rgba(58,52,51,0.7)',
  background: 'rgba(255,255,255,1)',
  backgroundVariant: 'rgba(251,249,249,1)',
  border: 'rgba(58,52,51,0.12)',
  borderLight: 'rgba(58,52,51,0.05)',
  iconNeutral: 'rgba(58,52,51,0.4)',
  iconHover: 'rgba(58,52,51,0.75)',
};

const darkTheme: Theme = {
  primary: 'rgba(220,120,95,1)',
  text: 'rgba(241,233,231,1)',
  textSecondary: 'rgba(241,233,231,0.6)',
  background: 'rgba(0,0,0,1)',
  backgroundVariant: 'rgba(28,26,26,1)',
  border: 'rgba(241,233,231,0.15)',
  borderLight: 'rgba(241,233,231,0.05)',
  iconNeutral: 'rgba(241,233,231,0.4)',
  iconHover: 'rgba(241,233,231,0.75)',
};

export type Theme = typeof lightTheme;

export const themes = {
  light: lightTheme,
  dark: darkTheme,
};

export const colors = {
  teal: {
    50: '#E0F2F1',
    100: '#B2DFDB',
    200: '#80CBC4',
    300: '#4DB6AC',
    400: '#26A69A',
    500: '#009688',
    600: '#00897B',
    700: '#00796B',
    800: '#00695C',
    900: '#004D40',
    A100: '#A7FFEB',
    A200: '#64FFDA',
    A400: '#1DE9B6',
    A700: '#00BFA5',
  },
  purple: {
    50: '#F3E5F5',
    100: '#E1BEE7',
    200: '#CE93D8',
    300: '#BA68C8',
    400: '#AB47BC',
    500: '#8E24AA',
    600: '#7B1FA2',
    700: '#6A1B9A',
    800: '#4A148C',
    900: '#38006B',
    A100: '#EA80FC',
    A200: '#E040FB',
    A400: '#D500F9',
    A700: '#AA00FF',
  },
  emerald: {
    50: '#E8F6E9',
    100: '#C5E1C8',
    200: '#9DCCA3',
    300: '#75B67E',
    400: '#57A661',
    500: '#388E3C',
    600: '#328136',
    700: '#2B712E',
    800: '#236127',
    900: '#1B4F1A',
    A100: '#B9F6CA',
    A200: '#69F0AE',
    A400: '#00E676',
    A700: '#00C853',
  },
  amber: {
    50: '#FFF8E1',
    100: '#FFECB3',
    200: '#FFE082',
    300: '#FFD54F',
    400: '#FFCA28',
    500: '#FFC107',
    600: '#FFB300',
    700: '#FFA000',
    800: '#FF8F00',
    900: '#FF6F00',
    A100: '#FFE57F',
    A200: '#FFD740',
    A400: '#FFC400',
    A700: '#FFAB00',
  },
  red: {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#B9272C',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000',
  },
  blue: {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff',
  },

  orange: {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00',
  },
  green: {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4CAF50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853',
  },
  grey: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161',
  },
  cobalt: {
    50: '#E1F3FF',
    100: '#BBE3FF',
    200: '#8CD3FF',
    300: '#54BFFF',
    400: '#2FB0FF',
    500: '#0091EA', // Primary
    600: '#0082D4',
    700: '#006EBB',
    800: '#005CA3',
    900: '#004A8A',
    A100: '#A6D5FA',
    A200: '#40B7FF',
    A400: '#0098FF',
    A700: '#0082DB',
  },
  crimson: {
    50: '#FCE4EC',
    100: '#F8BBD0',
    200: '#F48FB1',
    300: '#F06292',
    400: '#EC407A',
    500: '#C2185B', // Primary
    600: '#B31751',
    700: '#A31545',
    800: '#931239',
    900: '#840E2F',
    A100: '#FF80AB',
    A200: '#FF4081',
    A400: '#F50057',
    A700: '#C51162',
  },
  amethyst: {
    50: '#EDE7F6',
    100: '#D1C4E9',
    200: '#B39DDB',
    300: '#9575CD',
    400: '#7E57C2',
    500: '#5E35B1', // Primary
    600: '#512DA8',
    700: '#4527A0',
    800: '#311B92',
    900: '#251679',
    A100: '#B388FF',
    A200: '#7C4DFF',
    A400: '#651FFF',
    A700: '#6200EA',
  },
  jade: {
    50: '#E8F6F1',
    100: '#C8E9DD',
    200: '#A5DBC8',
    300: '#7DCDB2',
    400: '#5EC3A2',
    500: '#3DAB8B', // Primary
    600: '#359E80',
    700: '#2C8E72',
    800: '#237E64',
    900: '#1A6E56',
    A100: '#9DFFD3',
    A200: '#64FFBA',
    A400: '#1EFF9C',
    A700: '#00E883',
  },
  coral: {
    50: '#FFF0ED',
    100: '#FFD9D1',
    200: '#FFC1B3',
    300: '#FFA894',
    400: '#FF957D',
    500: '#FF7A5C', // Primary
    600: '#F06A4E',
    700: '#E0563D',
    800: '#D1432D',
    900: '#C2300D',
    A100: '#FFD0C7',
    A200: '#FF9E8C',
    A400: '#FF6B51',
    A700: '#FF4A28',
  },
};

export const FeatureColor = {
  mockGen: colors.green,
  autoGrade: colors.orange,
  profile: colors.cobalt,
};

export const SubjectColor = {
  mathematics: colors.cobalt,
  chinese: colors.crimson,
  english: colors.amethyst,
  physics: colors.teal,
  chemistry: colors.purple,
  biology: colors.emerald,
  economics: colors.amber,
};

export const PaperColor = {
  p1: colors.jade,
  p2: colors.jade,
};

export const CustomDimensions = {
  containerRadius: '16px',
  cornerRadius: '12px',
  iconSize: '24px',
  bodyMaxWidth: '700px',
};

export const otherColor = {
  darkGrey: "hsl(0, 0%, 36%)",
  text: "#5D5D5D",
  light: {
    green: "#D1EBC4",
    orange: "#EBD6C4",
    blue: "#C4D9EB",
  },
};

export const cardColorVariant = {
  "&.purple": {
    backgroundColor: "#D1C4E9",
  },
  "&.red": {
    backgroundColor: "#F8BBD0",
  },
  "&.green": {
    backgroundColor: "#D1EBC4",
  },
  "&.orange": {
    backgroundColor: "#EBD6C4",
  },
  "&.blue": {
    backgroundColor: "#BBE3FF",
  },
};